import React from 'react';
import { rem, SettingsItem, SettingsSection, TextButtonLinkSeeAll, } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import { StyleSheet } from 'react-native';
import { useHelpArticlesSearch } from '../hooks/useHelpArticlesSearch';
import FAQSection from './FAQSection';
const RecommendedArticles = ({ headerTitle, articles, noMarginTop, onSeeAllPress, omitFaq, }) => {
    const { openHelpArticle } = useHelpArticlesSearch();
    if (!headerTitle || !articles?.length) {
        return omitFaq ? null : <FAQSection noMarginTop={noMarginTop}/>;
    }
    return (<>
      <SectionHeader horizontalMargins style={[styles.marginBottom, !noMarginTop && styles.marginTop]} button={onSeeAllPress ? (<TextButtonLinkSeeAll onPress={onSeeAllPress}/>) : null}>
        {headerTitle}
      </SectionHeader>
      <SettingsSection noMarginTop>
        {articles.map((article) => (<SettingsItem key={article.article_id} title={article.title} onPress={() => openHelpArticle(article.url)}/>))}
      </SettingsSection>
    </>);
};
const styles = StyleSheet.create({
    marginTop: {
        marginTop: rem(24),
    },
    marginBottom: {
        marginBottom: rem(16),
    },
});
export default RecommendedArticles;
